import SvgArrowTxt from "./svg-arrow-txt";

export default SvgArrowTxt;
